import { createSelector } from '@reduxjs/toolkit';

import { getFilters } from './getFilters';

export const getReadyApartments = createSelector(getFilters, state => state.readyApartments);
